<div class="container">
  <h1>
    @if (projectInfo?.ProjectName) {
      <span> Subscribe to {{ projectInfo?.ProjectName }} </span>
    } @else {
      Subscribe to the Project
    }
  </h1>
  <div class="step">
    <p>Enter your information to see if you are subscribed!</p>
  </div>

  <app-global-search-stakeholder
    (formResult)="handleStakeholderSearchResult($event)"
    (formValidity)="handleFormValidity($event)"
    [emitOnSubmit]="onStakeholderSearch"
    [removeOnBlur]="true"
  ></app-global-search-stakeholder>

  <div class="button-container">
    <button
      [disabled]="!this.isStakeholderSearchValid || this.isLoadingMatchingStakeholders()"
      (click)="this.onSubmit()"
      class="blue-button"
    >
      Submit
    </button>
  </div>
</div>
